module.exports = function(frameUrl, initializeContent = {}) {
    this._sendMessage('popup', {frameUrl, initializeContent});
    return new this.PopupWidget(this);
};